module.exports = __webpack_public_path__ + "img/gh-36204-4-7.prt.a6db3a55.jpg";